import { render, staticRenderFns } from "./myanswer.vue?vue&type=template&id=7576ebe3&scoped=true&"
import script from "./myanswer.vue?vue&type=script&lang=js&"
export * from "./myanswer.vue?vue&type=script&lang=js&"
import style0 from "./myanswer.vue?vue&type=style&index=0&id=7576ebe3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7576ebe3",
  null
  
)

export default component.exports